import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { FaFilter } from 'react-icons/fa';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { CSVLink } from 'react-csv';

import ApiUiController from '../../controller/ApiUiController';
import FieldController from '../../controller/FieldController';
import ReportController from '../../controller/ReportController';
import ReportAPI from '../../api/ReportAPI';
import FilterDate from '../filter/FilterDate';
import FilterComplexPannel from '../filter/FilterComplexPannel';
import FilterMultiSelect from '../filter/FilterMultiSelect';
import Util from '../../util/Util';
import withRouter from '../../util/WithRouter';
import Const from '../../util/Constants';

class ReportComplexSelectToSelect extends React.Component {

  constructor(props) {
    super(props);
    this.models = reactLocalStorage.getObject(Const.Model);

    this.export = [];

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    this.children = [user.user_id, ...user.child];

    this.report = props.report;
    this.headers = [];
    this.rows = [];
    this.data = null;
    this.state = { isFilterOpen: true, inApiCall: false };

    const x = this.report.x.split('.')[0];
    this.x = this.report.x.split('.')[1];
    const y = this.report.y.split('.')[0];
    this.y = this.report.y.split('.')[1];

    if (this.report.model.includes(` ${x}`)) {
      this.modelX = this.models[this.report.model.split(' ')[0]];
    } else if (this.report.model.includes(` ${y}`)) {
      this.modelY = this.models[this.report.model.split(' ')[0]];
    }

    if (this.report.sub_model.includes(` ${x}`)) {
      this.modelX = this.models[this.report.sub_model.split(' ')[0]];
    } else if (this.report.sub_model.includes(` ${y}`)) {
      this.modelY = this.models[this.report.sub_model.split(' ')[0]];
    }

    this.RestrictX = Util.isAllow(this.modelX.permission, Const.PermRestricAcc);
    this.RestrictY = Util.isAllow(this.modelY.permission, Const.PermRestricAcc);

    const filters = [];
    if (this.report.filter) {
      const filter = JSON.parse(this.report.filter);
      for (let i = 0; i < filter.length; i++) {
        filters.push({ ...filter[i] });
        filters[i].value = FilterDate.getValue(filters[i].value ? filters[i].value : filters[i].condition);
        filters[i].value = FilterMultiSelect.getDefaultValue(filters[i].value);
      }
    }
    this.filters = filters;
  }

  componentDidMount() {
    this.loadReports();
  }

  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onData = res => {
    this.res = res;
    this.data = this.calculte(res);
    this.setState({ ...this.state, inApiCall: false });
  };

  onFilterChange = filters => {
    this.setState({ ...this.state, inApiCall: true });
    this.filters = filters;
    this.loadReports();
  };

  loadReports = () => {
    const restrict = this.filters.find(filter => filter.field === 'responsible_person');
    if (this.Restrict && !restrict) {
      this.filters.push({
        field: 'responsible_person', type: 'multiselect~user',
        condition: 'in', value: `${Const.Opt}${this.children.join(Const.Opt)}${Const.Opt}`
      });
    }
    ReportAPI.data(this.report.id, this.filters, this.onData, this.onFail);
  };

  calculte = res => {
    const x = this.x;
    const xType = this.modelX.fields[x].field_type.includes(Const.MultiSelect);

    const user = reactLocalStorage.getObject(Const.LoggedInUser);
    const children = [user.user_id, ...user.child];
    let xOptions = FieldController.getOptions(this.modelX.fields[x], undefined, true);
    if (this.RestrictX && this.modelX.fields[x].field_type.includes('~user')) {
      xOptions = xOptions.filter(opt => children.find(child => parseInt(child) === parseInt(opt.value)) !== undefined);
    }
    let filter = this.filters.find(filter => filter.field === this.modelX.fields[x].field_key
      && filter.model_key === this.modelX.model_key);
    if (filter) {
      xOptions = xOptions.filter(opt => filter.value.includes(`${Const.Opt}${opt.value}${Const.Opt}`));
    }
    this.xOptions = xOptions;

    const headers = xOptions.map(option => option.label);
    headers.push('Total');

    let yOpts = ReportController.getHeaderMonth(this.filters, this.modelY.fields[this.y]);
    this.yOptions = yOpts;
    const rows = yOpts.map(option => option.label);

    const body = [];
    const mainTotal = ['Total'];
    for (let j = 0; j < headers.length - 1; j++) {
      mainTotal.push(0);
    }
    mainTotal.push(0);

    const mainTotalCount = [''];
    for (let j = 0; j < headers.length - 1; j++) mainTotalCount.push(0);
    mainTotalCount.push(0);

    for (let i = 0; i < yOpts.length; i++) {
      let row = [rows[i]];
      const yData = res.filter(data => ReportController.isIn(yOpts[i].value, data[this.y]));
      let rowTotal = 0;
      for (let j = 0; j < xOptions.length; j++) {
        const rData = xType ? yData.filter(data => data[this.x] && data[this.x].includes(`${Const.Opt}${xOptions[j].value}${Const.Opt}`))
          : yData.filter(data => data[this.x] === xOptions[j].value);
        let total = 0;
        rData.map(data => total += data.sum);
        if (this.report.model === Const.TextCall) {
          row.push(`${total} (${rData.length})`);
        } else {
          row.push(total);
        }
        rowTotal += total;
        mainTotal[j + 1] += total;
        mainTotalCount[j + 1] += rData.length;
      }
      mainTotal[mainTotal.length - 1] += rowTotal;
      if (this.report.model === Const.TextCall) {
        row.push(`${rowTotal} (${yData.length})`);
      } else {
        row.push(`${rowTotal}`);
      }
      body.push(row);
    }

    for (let j = 1; j < mainTotal.length; j++) {
      if (this.report.model === Const.TextCall) {
        mainTotal[j] = `${mainTotal[j]} (${mainTotalCount[j]})`;
      } else {
        mainTotal[j] = `${mainTotal[j]}`;
      }
    }
    body.push(mainTotal);

    this.export = [[this.modelY.fields[this.y].label_name, ...headers], ...body];
    return { headers, body };
  };

  loadView = (i, j) => { };

  render() {
    const headers = this.data && this.data.headers ? this.data.headers.map((header, i) =>
      <th key={`table_header_${i + 1}`}>{header}</th>) : null;
    const body = this.data && this.data.body ?
      this.data.body.map((row, i) =>
        <tr key={`body_${i}`}>{row.map((item, j) =>
          <td key={`body_${i}_${j}`} onClick={() => this.loadView(i, j)}>{item}</td>)}</tr>)
      : null;

    const table = <Table striped bordered hover>
      <thead>
        <tr>
          <th key="table_header_0">
            {this.modelY.fields[this.y].label_name}
          </th>
          {headers}
        </tr>
      </thead>
      <tbody className="listlead">{body}</tbody>
    </Table>;

    if (this.props.dashbaord) {
      return (
        <div className="col-md-6">
          <div className="dashboard-report-titles mt-3">{this.report.name}</div>
          <div> <ApiUiController inApiCall={this.state.inApiCall}> {table} </ApiUiController> </div>
        </div>
      );
    }
    return (
      <ApiUiController inApiCall={this.state.inApiCall}>
        <div className="container-fluid ">
          <div className="row">
            <div className="col-md-8">
              <div className="row">
                <div className="col-md-6"><h4>{this.report.name}</h4></div>
                <div className="col-md-6">
                  <CSVLink data={this.export}>
                    <Button className="buttons btn-success">Export</Button>
                  </CSVLink>
                </div>
              </div>
            </div>

            <div className="col-md-4 pt-1">
              <div className="row filterrow">
                <div className="col-md-12 lastcol">
                  <div className="m-right">
                    <div className="btn btn-lead btn-sm filter-button"
                      onClick={() => this.setState({ ...this.state, isFilterOpen: !this.state.isFilterOpen })}>
                      <FaFilter />
                      <span className="badge badge-danger badge-mini rounded-circle">
                        {this.filters.length}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row pt-3">
            <div className="container-fluid ">
              <div className="row">
                <div className={`col-md-${this.state.isFilterOpen ? 9 : 12}`}>
                  {table}
                </div>
                {this.state.isFilterOpen ?
                  <FilterComplexPannel
                    filters={this.filters}
                    modelX={this.modelX}
                    modelY={this.modelY}
                    onFilterChange={this.onFilterChange}
                    isFilterOpen={this.state.isFilterOpen}
                    restrict={this.Restrict} />
                  : null
                }
              </div>
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}
export default withRouter(ReportComplexSelectToSelect);